import { yupResolver } from "@hookform/resolvers/yup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import {
  clearEvaluacionesPGD,
  evaluacionPorPGD,
  objetivosPorPGD,
  observacionesEvaluacionPGD,
  enviarObjetivos,
  obtenerEmpleadosQueReportanAUsuario
} from "../Redux/evaluaciones";
import { COLUMNSOBJETIVOS } from "../columnas/columnasObjetivos";
import { UserAuth } from "../context/AuthContext";
import TokenContext from "../context/TokenContext";
import Header from "./Header";
import Tabla from "./Tabla";
import ModalObjetivo from "./modales/ModalObjetivo";
import { nuevoEstadoPGD } from "../Redux/PGD";
import ModalConfirmacion from "./modales/ModalConfirmacion";
import { obtenerCompetenciasEvaluado, obtenerCompetenciasLider, obtenerLeyendasObjetivos } from "../Redux/autocompletados";
import TablaObservacionesPGD from "./tablas/TablaObservacionesPGD";
import { COLUMNSOBSERVACIONESOBJ } from "../columnas/columnasObjetivosFeedback";
import ModalObservaciones from "./modales/ModalObservaciones";
import TablaAvancesXobjetivos from "./tablas/TablaAvancesXobjetivos";
import ModalAvances from "./modales/ModalAvances";
import moment from "moment";
import { toast } from "react-toastify"
import useObjetivosPGD from "./hooks/useObjetivosPGD";
import useObservacionesPGD from "./hooks/useObservacionesPGD";
import ModalCancelarObjetivo from "./modales/ModalCancelarObjetivo";

const DesempenioAutoEvaluacion = () => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const { empleado } = UserAuth();
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation()
  const { getPgdObjetivos, objetivosPGD, targetObjetivo, setGetPgdObjetivos, setObjetivosPGD, setTargetObjetivo, targetObjetivoCancel, setTargetObjetivoCancel, handleObjetivo, handleCancelObjetivo, openModalModo, setOpenModalModo, openModalNuevoObjetivo, setOpenModalNuevoObjetivo, openModalCancelObjetivo, setOpenModalCancelObjetivo } = useObjetivosPGD(token, id)
  const evaluacionPGDSelector = useSelector((store) => store.evaluaciones.evaluacionPGD);

  const getItemsEvaluacionPDGSelector = useSelector((store) => store.evaluaciones.getItemsEvaluacionPDG);
  const itemsEvaluacionPGDSelector = useSelector((store) => store.evaluaciones.itemsEvaluacionPGD);

  const getPgdMetasSelector = useSelector((store) => store.evaluaciones.getPgdMetas);
  const pgdMetasSelector = useSelector((store) => store.evaluaciones.pgdMetas);

  const [getPgdMetas, setGetPgdMetasSelector] = useState(false);
  const [pgdMetas, setPgdMetas] = useState([]);
  const [isLider, setIsLider] = useState(null);
  const [idLider, setIdLider] = useState("");
  const [getdeAutoevaluacion, setGetdeAutoevaluacion] = useState("");

  const { observacionesEvaluacion, targetObservaciones, setObservacionesEvaluacion, setTargetObservaciones, handleOpenObservaciones, openModalObservaciones, setOpenModalObservaciones } = useObservacionesPGD(token, id)


  const [openModalConfirmacion, setOpenModalConfirmacion] = useState(false)
  const [openModalAvances, setOpenModalAvances] = useState(false)


  const [compLider, setCompLider] = useState([])
  const competenciaLselector = useSelector(store => store.autocompletados.competenciasLider)

  const [compEvaluado, setCompEvaluado] = useState([])
  const competenciaEselector = useSelector(store => store.autocompletados.competenciasEvaluado)

  const [empleadosReportaA, setEmpleadosReportaA] = useState(false)
  const empleadosReportaAselector = useSelector(store => store.evaluaciones.empleadosReportaA)

  const [leyendaObjetivos, setLeyendaObjetivos] = useState({})
  const leyendaObjetivoSelector = useSelector(store => store.autocompletados.leyendaObjetivo)

  const [idAvancesMensuales, setIdAvancesMensuales] = useState("")
  const [textoObjetivos, setTextoObjetivos] = useState("")

  const [leyendaEtapa1, setLeyendaEtapa1] = useState("")
  const [leyendaEtapa2, setLeyendaEtapa2] = useState("")

  const defaultValues = {
    miProposito: null,
    cambiosEnProposito: null,
    comentariosObservaciones: null,
    comentariosObservacionesMiAspiracional: null,
    interesDesarrolloProx12Meses: null,
    puestoAspiracionaProx12Meses: null,
    unidadOrganizativaAspiracionalProx12Meses: null,
    interesDesarrolloProx24Meses: null,
    puestoAspiracionaProx24Meses: null,
    unidadOrganizativaAspiracionalProx24Meses: null,
  };

  const validacionSchema = yup.object().shape({
    cambiosEnProposito: yup.object().required("Required"),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { reset } = methods;

  useEffect(() => {
    const empleadoId = empleado.empleadoid;

    if (empleadoId === undefined) {
      setIsLider(null);
      setTextoObjetivos("")
    } else {
      if( empleadoId && idLider) {
        if (empleadoId === idLider) {
          setIsLider(true);
          setTextoObjetivos("Objetivos del colaborador")
        } else {
          setIsLider(false);
          setTextoObjetivos("Mis Objetivos")
        }
      }
    }
  }, [idLider, empleado]);

  useEffect(() => {
    if (objetivosPGD?.length > 0) {
      const objeto = getdeAutoevaluacion[0];
      reset({
        ...defaultValues,
        ...objeto,
      });
    }
    if(getdeAutoevaluacion?.length > 0) {
      dispatch(obtenerEmpleadosQueReportanAUsuario(token, getdeAutoevaluacion[0].evaluadoid))
    }
  }, [getdeAutoevaluacion]);

  useEffect(() => {
    if (id?.length > 0 && token) {
      dispatch(objetivosPorPGD(token, id));
      dispatch(evaluacionPorPGD(token, id));
      dispatch(obtenerCompetenciasLider(token));
      dispatch(obtenerCompetenciasEvaluado(token));
      dispatch(obtenerLeyendasObjetivos(token))
    }
  }, [id, token]);

  useEffect(() => {
    if (evaluacionPGDSelector?.length > 0) {
      const array = [];
      evaluacionPGDSelector.forEach((items) => {
        setIdLider(items["_new_lder_value"]);
        let item = {
          id: items["new_evaluaciondepgdid"],
          objetivo: items["new_name"],
          lider: items["_new_lder_value"],
          evaluadoid: items["_new_evaluado_value"],
          nombreEvaluado: items["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
          fechaDeCarga: items["createdon@OData.Community.Display.V1.FormattedValue"],
          fechaDeInicioAutoevaluacion: items["new_fechainicioautoevaluacion"],
          estadodelaautoevaluacin: items["new_estadodelaautoevaluacin"],
          estadodelaevaluacindellde: items["new_estadodelaevaluacindellder"],
          peso: items.new_ponderacionlider,
          indicador: items.new_resultadoclave,
          status: items["evaluacion.statuscode@OData.Community.Display.V1.FormattedValue"],
          statuscode: items["statuscode"],
          porcentajeAvance: "",
          estado: items["statuscode@OData.Community.Display.V1.FormattedValue"],
          miProposito: items["new_nuevoproposito"],
          cambiosEnProposito: items[""],
          comentariosObservaciones: items["new_comentariosyobervacionesdesuproposito"],
          comentariosObservacionesMiAspiracional: items["new_comentariosyobservacionesdemiproposito"],
          interesDesarrolloProx12Meses: {
            value: items["new_interesendesarrolloprox6meses"],
            label:
              items[
              "new_interesendesarrolloprox6meses@OData.Community.Display.V1.FormattedValue"
              ],
          },
          puestoAspiracionaProx12Meses: {
            value: items["_new_puestoaspiracionalprximos6meses_value"],
            label:
              items[
              "_new_puestoaspiracionalprximos6meses_value@OData.Community.Display.V1.FormattedValue"
              ],
          },
          unidadOrganizativaAspiracionalProx12Meses: {
            value:
              items["_new_unidadorganizativaaspiracionalprximos6mes_value"],
            label:
              items[
              "_new_unidadorganizativaaspiracionalprximos6mes_value@OData.Community.Display.V1.FormattedValue"
              ],
          },
          interesDesarrolloProx24Meses: {
            value: items["new_interesendesarrolloprximos12meses"],
            label:
              items[
              "new_interesendesarrolloprximos12meses@OData.Community.Display.V1.FormattedValue"
              ],
          },
          puestoAspiracionaProx24Meses: {
            value: items["_new_puestoaspiracionalprximos12meses_value"],
            label:
              items[
              "_new_puestoaspiracionalprximos12meses_value@OData.Community.Display.V1.FormattedValue"
              ],
          },
          unidadOrganizativaAspiracionalProx24Meses: {
            value:
              items["_new_unidadorganizativaaspiracionalprximos12me_value"],
            label:
              items[
              "_new_unidadorganizativaaspiracionalprximos12me_value@OData.Community.Display.V1.FormattedValue"
              ],
          },
          new_fechalimiteobjetivos: items["aa.new_fechalimiteobjetivos"],
        };
        array.push(item);
      });
      setGetdeAutoevaluacion(array);
    }
    if (
      itemsEvaluacionPGDSelector?.length > 0 &&
      getItemsEvaluacionPDGSelector
    ) {
      const array = [];
      itemsEvaluacionPGDSelector.forEach((items) => {
        let item = {
          id: items["new_itemdeevaluaciondedesempeoid"],
          competencia:
            items[
            "_new_competencia_value@OData.Community.Display.V1.FormattedValue"
            ],
          valoracion:
            items["new_valoracin@OData.Community.Display.V1.FormattedValue"],
          valoracionModal: {
            value: items["new_valoracin"],
            label:
              items["new_valoracin@OData.Community.Display.V1.FormattedValue"],
          },
          valoracionLider:
            items[
            "new_valoraciondellider@OData.Community.Display.V1.FormattedValue"
            ],
          valoracionLiderModal: {
            value: items["new_valoraciondellider"],
            label:
              items[
              "new_valoraciondellider@OData.Community.Display.V1.FormattedValue"
              ],
          },
        };
        array.push(item);
      });
    }
    if (pgdMetasSelector?.length > 0 && getPgdMetasSelector) {
      const array = [];
      pgdMetasSelector.forEach((items) => {
        let item = {
          id: items["new_metaprioritariaid"],
          metaDesarrollo: items["new_name"],
          accion: items["new_accion"],
          tipoAccion:
            items["new_tipodeaccin@OData.Community.Display.V1.FormattedValue"],
          fechaDesde:
            items["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta:
            items["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          estado: items["statuscode@OData.Community.Display.V1.FormattedValue"],
        };
        array.push(item);
      });
      setPgdMetas(array);
      setGetPgdMetasSelector(getPgdMetasSelector);
    } else if (
      itemsEvaluacionPGDSelector?.length === 0 &&
      getPgdMetasSelector
    ) {
      setGetPgdMetasSelector(getPgdMetasSelector);
    }

  }, [
    itemsEvaluacionPGDSelector,
    pgdMetasSelector,
    evaluacionPGDSelector,
  ]);



  useEffect(() => {
    if (competenciaLselector.length > 0) {
      const newArray = competenciaLselector.map((element) => ({
        value: element.new_competenciaid,
        label: element.new_name
      }))

      setCompLider(newArray)
    }
  }, [competenciaLselector])

  useEffect(() => {
    if (competenciaEselector.length > 0) {
      const newArray = competenciaEselector.map((element) => ({
        value: element.new_competenciaid,
        label: element.new_name
      }))

      setCompEvaluado(newArray)
    }
  }, [competenciaEselector])

  useEffect(() => {
    if (empleadosReportaAselector.length > 0) {
      setEmpleadosReportaA(true)
    } else {
      setEmpleadosReportaA(false)
    }
  }, [empleadosReportaAselector])

  useEffect(() => {
    if (leyendaObjetivoSelector.length > 0) {
      const newArray = leyendaObjetivoSelector.map((element) => ({
        id: element.new_maestrodeleyendaspgdid,
        new_nombredeobjetivo: element.new_nombredeobjetivo,
        new_pesodeobjetivo: element.new_pesodeobjetivo,
        new_resultadoclavedeobjetivo: element.new_resultadoclavedeobjetivo,
        new_competenciadeobjetivo: element.new_competenciadeobjetivo
      }))
      setLeyendaObjetivos(newArray[0])

      // Extraer las propiedades y guardarlas en estados
      const definicionObjetivos = leyendaObjetivoSelector[0]?.new_autoevaluacionintroduccion;
      const gestionSeguimiento = leyendaObjetivoSelector[0]?.new_evaluacinintroduccin;

      setLeyendaEtapa1(definicionObjetivos)
      setLeyendaEtapa2(gestionSeguimiento)

    }
  }, [leyendaObjetivoSelector])

  const handleVolverAtras = () => {
    navigate("/pgd", { state: { activeTab: location.state?.activeTab || "1" } });
    dispatch(clearEvaluacionesPGD());
  };

  const handleCloseModalNuevoObjetivo = (objetivo, idPGDObjetivo, indice) => {
    if (objetivo) {
      if (!objetivo.id) { // Objetivo nuevo
        if(indice == null || indice == undefined) { //Agregar objetivo nuevo
          let item = {
            id: objetivo.id ? objetivo.id : null,
            objetivo: objetivo.objetivo,
            fechaDeCarga: objetivo.fechaDeCarga ? objetivo.fechaDeCarga : null,
            fechaDeCumplimiento: objetivo.fechaDeCumplimiento ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : null,
            peso: objetivo.peso,
            competencia: objetivo.competencia? objetivo.competencia : null,
            competencia2: objetivo.competencia2 ? objetivo.competencia2 : null,
            indicador: objetivo.indicador,
            indicador2: objetivo.indicador2 ? objetivo.indicador2 : null,
            indicador3: objetivo.indicador3 ? objetivo.indicador3 : null,
            indicador4: objetivo.indicador4 ? objetivo.indicador4 : null,
            indicador5: objetivo.indicador5 ? objetivo.indicador5 : null,
            competenciaPrimaria: objetivo.competencia ? objetivo.competencia.label : null,
            competenciaSecundaria: objetivo.competencia2 ? objetivo.competencia2.label : null,
            idEvaluacion: idPGDObjetivo,
            statusSelect : { value: 100000004, label: "No iniciado" },
          }

          setObjetivosPGD((prevObjetivosPGD) => [...prevObjetivosPGD, item]);
        }
        else { // Editar Objetivo Nuevo
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD[indice].fechaDeCumplimiento = objetivo.fechaDeCumplimiento ? (moment.isMoment(objetivo.fechaDeCumplimiento) ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : objetivo.fechaDeCumplimiento): null;
          nuevosObjetivosPGD[indice].peso = objetivo.peso;
          nuevosObjetivosPGD[indice].indicador = objetivo.indicador;
          nuevosObjetivosPGD[indice].indicador2 = objetivo.indicador2;
          nuevosObjetivosPGD[indice].indicador3 = objetivo.indicador3;
          nuevosObjetivosPGD[indice].indicador4 = objetivo.indicador4;
          nuevosObjetivosPGD[indice].indicador5 = objetivo.indicador5;

          setObjetivosPGD(nuevosObjetivosPGD);
        }
      } else { //Editar Objetivo Existente en BO
        let index = objetivosPGD.findIndex((item) => item.id === objetivo.id);

        if (index !== -1) {
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD[index].fechaDeCumplimiento = objetivo.fechaDeCumplimiento ? (moment.isMoment(objetivo.fechaDeCumplimiento) ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : objetivo.fechaDeCumplimiento) : null;
          nuevosObjetivosPGD[index].peso = objetivo.peso;
          nuevosObjetivosPGD[index].indicador = objetivo.indicador;
          nuevosObjetivosPGD[index].indicador2 = objetivo.indicador2;
          nuevosObjetivosPGD[index].indicador3 = objetivo.indicador3;
          nuevosObjetivosPGD[index].indicador4 = objetivo.indicador4;
          nuevosObjetivosPGD[index].indicador5 = objetivo.indicador5;

          setObjetivosPGD(nuevosObjetivosPGD);
        }
      }
    }
    setOpenModalNuevoObjetivo(false)
    setOpenModalModo("")
    setTargetObjetivo({})
  };
  const handleCloseModalCancelarObjetivo = (objetivo, indice) => {
    if (objetivo) {
      if (!objetivo.id) {
        if(indice == null || indice == undefined) { //Agregar objetivo nuevo
          // No aplica, todos los objetivos a cancelar deberían tener un índice.
        }
        else { // Cancelar Objetivo Nuevo con índice que no fue creado en BO
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD.splice(indice, 1);
          setObjetivosPGD(nuevosObjetivosPGD);
        }
      } else { //Cancelar Objetivo Existente en BO
        let index = objetivosPGD.findIndex((item) => item.id === objetivo.id);
        if (index !== -1) {
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD[index].statusSelect = objetivo.motivoCancelar ? { value: 100000003, label: "Cancelado" } : null;
          nuevosObjetivosPGD[index].motivoCancelar = objetivo.motivoCancelar ? { value: objetivo.motivoCancelar.value, label: objetivo.motivoCancelar.label } : null;
          setObjetivosPGD(nuevosObjetivosPGD);
        }
      }
    }
    setOpenModalCancelObjetivo(false)
    setTargetObjetivoCancel({})
  };

  const handleCloseObservaciones = () => {
    setOpenModalObservaciones(false)
    setTargetObservaciones({})
  }

  const handleOpenAvances = (id) => {
    setOpenModalAvances(true)
    setIdAvancesMensuales(id)
  }

  const handleCloseAvances = () => {
    setOpenModalAvances(false)
    setIdAvancesMensuales("")
  }

  const nuevoObjetivo = () => {
    setOpenModalNuevoObjetivo(true);
    setOpenModalModo("nuevo");
  };

  const modalEnviarObjetivos = () => {
    setOpenModalConfirmacion(true)
  };

  const handleClose = (confirmacion) => {
    let peso = 0; // Inicializar la variable peso
  
    if (confirmacion && objetivosPGD.length > 0) {
      const array = objetivosPGD.map((objetivo) => {
        const newObjetivo = {
          "new_objetivodeevaluacionid": objetivo.id || "",
          "new_name": objetivo.objetivo,
          "new_evaluaciondepgd": objetivo.idEvaluacion,
          "new_resultadoclave": objetivo.indicador,
          "new_indicador2": objetivo.indicador2,
          "new_indicador3": objetivo.indicador3,
          "new_indicador4": objetivo.indicador4,
          "new_indicador5": objetivo.indicador5,
          "new_ponderacionlider": objetivo.peso,
          "new_competencia": objetivo.competencia ? objetivo.competencia.value : null,
          "new_competencia2": objetivo.competencia2 ? objetivo.competencia2.value : null,
          "new_fechadecumplimiento": objetivo.fechaDeCumplimiento || null,
          "new_status": objetivo.statusSelect ? objetivo.statusSelect.value : null,
          "new_motivodecancelaciondeobjetivo": objetivo.motivoCancelar ? objetivo.motivoCancelar.value : null,
        };

        if( objetivo.statusSelect && objetivo.statusSelect.value !== 100000001 && objetivo.statusSelect.value !== 100000003 ) {
          peso += objetivo.peso;
        }
        return newObjetivo;
      });
  
      if (array.length > 0) {
        if (peso === 100) {
          dispatch(enviarObjetivos(token, array))
            .then(() => dispatch(objetivosPorPGD(token, id)))
            .catch((error) => console.error("Error:", error));
        } else {
          toast.error('La suma completa de los objetivos activos debe ser igual a 100', {
            theme: "dark",
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }
  
    setOpenModalConfirmacion(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }}>
          <IconButton color={theme.palette.secondary[300]}>
            <ArrowBackIcon />
          </IconButton>
          <Typography color={theme.palette.secondary[300]}>
            Volver atrás
          </Typography>
        </Button>
        <Header
          title={
            getdeAutoevaluacion[0]?.statuscode === 100000000
              ? "Definición de Objetivos"
              : getdeAutoevaluacion[0]?.statuscode === 100000001
                ? "Gestión y Seguimiento"
                : getdeAutoevaluacion[0]?.statuscode === 100000002
                  ? "Balance y Cierre de Año"
                  : ""
          }
          subtitle={
            getdeAutoevaluacion[0]?.statuscode === 100000000
              ? leyendaEtapa1
              : getdeAutoevaluacion[0]?.statuscode === 100000001
              ? leyendaEtapa2
              : ""
          }
        />
        <Box sx={{ pb: 2 }} display="flex" flexDirection="column" alignItems="center">
          {
            isLider && (
              <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mt: "15px" }}>
                Evaluación de: {getdeAutoevaluacion[0]?.nombreEvaluado}	
              </Typography>
            )
          } 
        </Box>
        <Box sx={{ mt: 4 }}>
          <Typography
            variant="h5"
            color={theme.palette.secondary[50]}
            fontWeight="bold"
            sx={{ mb: "5px" }}
          >
            {textoObjetivos}
          </Typography>


          <Box sx={{ py: 2, display: "flex", justifyContent: "flex-start" }}>
            {
              isLider && (
                <Button
                  variant="contained"
                  onClick={nuevoObjetivo}
                  disabled={
                    objetivosPGD.filter(objetivo => 
                      (objetivo.statusSelect && objetivo.statusSelect.value !== 100000001 && objetivo.statusSelect.value !== 100000003)
                    ).length >= 5
                    ||
                    (getdeAutoevaluacion.length > 0 && 
                      getdeAutoevaluacion[0]?.new_fechalimiteobjetivos && 
                      new Date() > new Date(getdeAutoevaluacion[0]?.new_fechalimiteobjetivos)
                    )
                  }
                  >
                  Nuevo Objetivo
                </Button>
              )
            }
          </Box>
          {!getPgdObjetivos ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                py: 2,
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          ) : objetivosPGD.length > 0 ? (
            isLider!==null && (
              <TablaAvancesXobjetivos
                columnas={COLUMNSOBJETIVOS}
                lineas={objetivosPGD}
                header={true}
                acciones={true}
                handleOpen={handleObjetivo}
                handleCancel={handleCancelObjetivo}
                instancia={getdeAutoevaluacion[0]?.statuscode}
                isLider={isLider}
                idPGD={id}
              />
            )
          ) : (
            <Alert severity="info">
              <AlertTitle>Info</AlertTitle>
              Aún no tienes registros de <strong>objetivos</strong>.
            </Alert>
          )}

        </Box>
        <Box>
          <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}>
            {
              isLider && (
                <Button
                  variant="contained"
                  onClick={modalEnviarObjetivos}
                  disabled={ objetivosPGD.length === 0 }
                >
                  Guardar cambios
                </Button>
              )
            }
          </Box>
        </Box>

        {getdeAutoevaluacion[0]?.statuscode === 100000001 && (
          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h5"
              color={theme.palette.secondary[50]}
              fontWeight="bold"
              sx={{ mb: "5px" }}
            >
              Observaciones de Evaluación
            </Typography>
            <TablaObservacionesPGD
              columnas={COLUMNSOBSERVACIONESOBJ}
              lineas={observacionesEvaluacion}
              header={true}
              acciones={true}
              handleOpen={handleOpenObservaciones}
            />
          </Box>
        )}
      </Box>



      <ModalObjetivo
        open={openModalNuevoObjetivo}
        handleClose={handleCloseModalNuevoObjetivo}
        objetivo={targetObjetivo}
        openModalModo={openModalModo}
        idPGD={id}
        isLider={isLider}
        competenciasLider={compLider}
        competenciasEvaluado={compEvaluado}
        empleadosReportaA={empleadosReportaA}
        tipoAutoevaluacion={
          getdeAutoevaluacion[0]?.statuscode === 100000000
            ? "Definición de Objetivos"
            : getdeAutoevaluacion[0]?.statuscode === 100000001
              ? "Gestión y Seguimiento"
              : getdeAutoevaluacion[0]?.statuscode === 100000002
                ? "Balance y Cierre de Año"
                : ""
        }
        leyenda={leyendaObjetivos}
      />
      <ModalCancelarObjetivo
        open={openModalCancelObjetivo}
        handleClose={handleCloseModalCancelarObjetivo}
        objetivo={targetObjetivoCancel}
        idPGD={id}
      />
      <ModalConfirmacion
        open={openModalConfirmacion}
        handleClose={handleClose}
        texto={"Deseas enviar la evaluación?"}
      />
      <ModalObservaciones
        open={openModalObservaciones}
        handleClose={handleCloseObservaciones}
        data={targetObservaciones}
        isLider={isLider}
      />
    </motion.div>
  );
};

export default DesempenioAutoEvaluacion;
